<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta Termo de Moeda"
    [operationDate]="this.model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card">
    <div class="card-header text-uppercase">Tipo de lançamento</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('entryTypeId')">
          <div
            class="form-check form-check-inline"
            *ngFor="let item of TiposLancamento; index as i"
          >
            <input
              class="form-check-input"
              data-cy="entryTypeId"
              type="radio"
              id="{{ 'entryType-' + i + '-id' }}"
              name="entryTypeId"
              [value]="item.id"
              [(ngModel)]="model.entryTypeId"
            />
            <label
              class="form-check-label"
              for="{{ 'entryType-' + i + '-id' }}"
            >
              {{ item.name }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.CurrencyTerm"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4">
          <label>Tipo Operação</label>

          <app-radio-list
            [invalid]="this.model.operationTypeId == null && thisForm.touched"
            [list]="this.TiposOperacao"
            [(model)]="this.model.operationTypeId"
            name="operationTypeId"
            modelChange="this.model.operationTypeId = $event"
          >
          </app-radio-list>
        </div>

        <div class="col-4">
          <label for="tipo-cetip">Tipo Liquidação</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                type="checkbox"
                id="tipo-cetip"
                data-cy="cetipSettlement"
                name="cetipSettlement"
                class="form-check-input"
                [(ngModel)]="model.cetipSettlement"
              />
              <label for="tipo-cetip">CETIP</label>
            </div>
          </div>
        </div>

        <div class="col-3">
          <label>Valor Base</label>
          <input
            type="text"
            class="form-control"
            name="BaseValue"
            data-cy="BaseValue"
            [(ngModel)]="model.baseValue"
            maxlength="26"
            required
          />
        </div>
        <app-out-custody></app-out-custody>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Número Contrato</label>
          <input
            type="text"
            class="form-control"
            name="contractNumber"
            data-cy="contractNumber"
            [required]="isEarlySettlement()"
            [(ngModel)]="model.contractNumber"
            maxlength="15"
            [required]="model.entryTypeId == EntryTypeEnum.EarlySettlement"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('futureFee')">
          <label>Taxa Termo</label>
          <input
            type="text"
            class="form-control"
            name="futuraFee"
            data-cy="futureFee"
            [(ngModel)]="model.futureFee"
            required
            maxlength="8"
            [textMask]="{ mask: validator.decimalCommissionFeeMask }"
          />
        </div>

        <div class="col-4">
          <label>Cotação Vencimento</label>
          <mat-select
            [class.required-active]="
              thisForm.touched && this.model.quoteExpirationTypeId == null
            "
            data-cy="quoteExpirationTypeId"
            required
            class="form-control"
            [(value)]="this.model.quoteExpirationTypeId"
            [disabled]="!canEdit()"
          >
            <mat-option>(nenhum)</mat-option>

            <mat-option
              *ngFor="let item of listaCotacaovencimento"
              name="status"
              [value]="item.id"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Moeda</label>
          <mat-select
            [class.required-active]="
              thisForm.touched && this.model.currencyId == null
            "
            required
            data-cy="currencyId"
            class="form-control"
            [(value)]="this.model.currencyId"
            [disabled]="!canEdit()"
          >
            <mat-option *ngFor="let item of Moedas" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-4">
          <label>Cross Rate</label>
          <div
            [class.required-active]="
              model.crossRate == null && thisForm.touched
            "
          >
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                [(ngModel)]="model.crossRate"
                data-cy="crossRateTrue"
                id="termo-1"
                name="termo"
                type="radio"
                [value]="true"
                required
              />
              <label class="form-check-label" for="termo-1">Sim</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                [(ngModel)]="model.crossRate"
                data-cy="crossRateFalse"
                id="termo-0"
                name="termo"
                type="radio"
                [value]="false"
                required
              />
              <label class="form-check-label" for="termo-0">Não</label>
            </div>
          </div>
        </div>

        <div class="col-4" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>
          <input
            placeholder="Select date"
            #tradingDate
            type="date"
            class="form-control col-12"
            name="expirationDate"
            data-cy="expirationDate"
            [(ngModel)]="model.expirationDate"
            required
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="isEarlySettlement()">
        <div class="col-6">
          <label>Valor Financeiro em Reais</label>
          <input
            data-cy="financialValue"
            type="text"
            class="form-control"
            name="financialValue"
            required
            [(ngModel)]="model.financialValue"
            [textMask]="{ mask: validator.currencyMask }"
            maxlength="26"
            [required]="model.entryTypeId == EntryTypeEnum.EarlySettlement"
          />
        </div>
        <div class="col-6" [class.has-error]="hasError('interestFee')">
          <label>Taxa Juros</label>
          <input
            data-cy="interestFee"
            type="text"
            class="form-control"
            name="interestFee"
            required
            [(ngModel)]="model.interestFee"
            [textMask]="{ mask: validator.decimalCommissionFeeMask }"
            [required]="model.entryTypeId == EntryTypeEnum.EarlySettlement"
          />
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.CurrencyTerm"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  >
  </app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>
  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [canChangeStatus]="canChangeStatus()"
    [statusDescription]="model.statusDescription"
    (tempTicketId)="setTempId($event)"
  ></app-attachment>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      data-cy="submit"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Encaminhar"
      data-cy="forward"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      *ngIf="canCancel()"
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      data-cy="approve"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      data-cy="reject"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
  <app-workflow-history
    [ticketId]="model.id"
    [refresh]="dataChanged"
  ></app-workflow-history>
</form>
